// ABOUTME: Purchase order email template view on the warehouse Email settings page.
// ABOUTME: Thin wrapper around the shared EmailTemplateEditor; the mail announces an inbound to its supplier.

import EmailTemplateEditor from "../../../../../components/global/EmailTemplates/EmailTemplateEditor";
import { UserPrivileges } from "../../../../../utils/permissions";

const PurchaseOrder = (props) => (
    <EmailTemplateEditor
        {...props}
        type="purchaseorder"
        titleKey="purchaseorder_email"
        managePrivileges={[UserPrivileges.SETTINGS_GENERAL, UserPrivileges.SETTINGS_ALL]}
        showSubject
    />
);

export default PurchaseOrder;
